export default __webpack_public_path__ + "static/media/Google.92effba7.svg";